import { Tooltip } from 'antd';

import classes from './TransactionStatus.module.css';

const TRANSACTION_STATUS = {
  Paid: 'Paid',
  Unpaid: 'Unpaid',
  Refunded: 'Refunded',
  'To be refunded': 'To be refunded',
};
const TRANSACTION_STATUS_COLOR = {
  [TRANSACTION_STATUS.Paid]: '#AEE9D1',
  [TRANSACTION_STATUS.Unpaid]: '#FED3D1',
  [TRANSACTION_STATUS.Refunded]: '#AEC6E9',
  [TRANSACTION_STATUS['To be refunded']]: '#FED3D1',
};

// eslint-disable-next-line react/prop-types
export const TransactionStatus = ({ status, style = {}, tooltip }) => {
  const color = TRANSACTION_STATUS_COLOR[status];
  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top" color="#fff">
        <div className={classes.status} style={{ background: color, ...style }}>
          <div className={classes.status_text}>{status}</div>
        </div>
      </Tooltip>
    );
  }
  return (
    <div className={classes.status} style={{ background: color, ...style }}>
      <span className={classes.status_text}>{status}</span>
    </div>
  );
};
